export { default as default } from './EditarFontDeDadesComponent.jsx';